// @ts-nocheck
import styled from 'styled-components';

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50%;
    width: 50%;
`;

const SpaceAvatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;

    & img.space-avatar-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        border: ${props => props.withWinner ? props.isWinner ? '1.5px solid gold' : '1px solid white' : '1px solid white'};
    }
`;

const SpaceName = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    & h6.name-wrestler {
        font-size: 6px;
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
        line-height: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;


function RenderWrestlerWhenFourInSpace({ wrestler, side, withWinner = false }) {
    return (
        <SpaceWrestler className={`space-wrestler ${side}`}>
            <SpaceAvatar className='space-avatar'
             withWinner={withWinner}
             isWinner={wrestler.pivot.is_winner}
            >
                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='space-avatar-image' />
            </SpaceAvatar>
            <SpaceName className='space-name'>
                <h6 className='name-wrestler'>{wrestler.name}</h6>
            </SpaceName>
        </SpaceWrestler>
    )
}

export default RenderWrestlerWhenFourInSpace;